import script from "./ViewerDateAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewerDateAddress.vue?vue&type=script&setup=true&lang=ts"

import "./ViewerDateAddress.vue?vue&type=style&index=0&id=133eb153&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133eb153"]])

export default __exports__